import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type NewUserCohortFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id'>
  & { cohorts?: Types.Maybe<(
    { __typename: 'Cohorts' }
    & Pick<Types.Cohorts, 'userCohortPersonalProductivity'>
  )> }
);

export const NewUserCohortFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'NewUserCohort' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cohorts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'userCohortPersonalProductivity',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseNewUserCohortFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<NewUserCohortFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseNewUserCohortFragmentResult
  extends Omit<Apollo.UseFragmentResult<NewUserCohortFragment>, 'data'> {
  data?: NewUserCohortFragment;
}

export const useNewUserCohortFragment = ({
  from,
  returnPartialData,
  ...options
}: UseNewUserCohortFragmentOptions): UseNewUserCohortFragmentResult => {
  const result = Apollo.useFragment<NewUserCohortFragment>({
    ...options,
    fragment: NewUserCohortFragmentDoc,
    fragmentName: 'NewUserCohort',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as NewUserCohortFragment };
};
